export enum WartungsvertragPamentMethodSource {
  ADDRESS = 'ADDRESS',
  SERVICE_CONTRACT = 'SERVICE_CONTRACT',
}
